import ReactDOM from 'react-dom'
import './index.css'
const theme = process.env.REACT_APP_THEME || 'default'

if (theme === 'agoda') {
  require('./' + theme + '.css')
}

ReactDOM.render(require(`./route/${theme}`).default, document.getElementById('root'))
